const VimeoIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path d='M14.8177 2.58565C11.0253 2.49357 10.1472 6.25637 10.1472 6.25637C13.0053 5.47657 12.4485 7.49654 12.4485 7.49654C10.705 11.6821 9.71554 11.2199 9.71554 11.2199C8.67086 10.8497 7.98689 5.64944 7.98689 5.64944C7.38767 1.56908 4.8351 3.07514 4.8351 3.07514C3.30159 3.73469 0.75 6.26953 0.75 6.26953L1.54534 7.16771C2.9389 5.74151 3.45533 6.81163 3.45533 6.81163C4.40934 8.62773 5.04502 11.1945 5.04502 11.1945C6.3765 16.4032 8.15443 16.08 8.15443 16.08C12.5736 15.5502 16.6587 7.73518 16.6587 7.73518C18.6949 2.67866 14.8187 2.58565 14.8187 2.58565H14.8177Z' />
      </svg>
    </span>
  );
};

export default VimeoIcon;
